/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Shared horizontal spacing for the authenticated Ops shell (navigation and page chrome).
 * Theme `md` is 900px — matches MainLayout desktop vs mobile split.
 */

/** Emotion fragment for styled components — list page side margins. */
export const listPageGutterCss = `
  margin-left: 1rem;
  margin-right: 1rem;

  ${({ theme }: { theme: any }) => theme.breakpoints.up("md")} {
    margin-left: 4rem;
    margin-right: 4rem;
  }
`;

/** Edit/add pages via Container — tighter on phone, wide gutters on large desktop. */
export const formShellGutterCss = `
  padding-left: 1rem;
  padding-right: 1rem;

  ${({ theme }: { theme: any }) => theme.breakpoints.up("md")} {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  ${({ theme }: { theme: any }) => theme.breakpoints.up("lg")} {
    padding-left: 10rem;
    padding-right: 10rem;
  }
`;

export const formShellTitleGutterCss = `
  padding: 1.25rem 1rem 0;

  ${({ theme }: { theme: any }) => theme.breakpoints.up("md")} {
    padding: 1.25rem 4rem 0;
  }

  ${({ theme }: { theme: any }) => theme.breakpoints.up("lg")} {
    padding: 1.25rem 10rem 0;
  }
`;

/** Mobile top bar — logo + burger; desktop uses sidebar instead. */
export const mobileHeaderPaddingCss = `
  padding: 0.5rem 1rem;
  min-height: 64px;
  box-sizing: border-box;
`;
